<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <!-- 작업 정보-->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 작업 정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div class="writeGridLineItem">
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.작업내용 }}</p>
          <ml-input v-else v-model="form.작업내용" class="w-full" />
        </div>

        <div>
          <div>작업일시</div>
          <p v-if="isPrint" class="print-input">{{ form.작업일시 }}</p>
          <date-selector v-else v-model="form.작업일시" class="w-full" />
        </div>
        <div>
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ form.작업장소 }}</p>
          <ml-input v-else v-model="form.작업장소" class="w-full" />
        </div>
        <div>
          <div>작업업체</div>
          <p v-if="isPrint" class="print-input">{{ form.작업업체 }}</p>
          <ml-input v-else v-model="form.작업업체" class="w-full" />
        </div>

      </div>
    </div>

    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="밀폐공간 프로그램 평가표"
      table-header-title="점검항목"
      :table-header-note="[
        { text: '비고', width: '389' },
        ]"
      contentBefore="numbering"
      v-model="form.inspectList"
      class="mt-28px"
      :only-pc="isPrint"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import * as inspectData from "./inspectData";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector, TimeSelector,
    TableInspectMerge,
    FileUploadModule,
    TableInspect,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],
        inspectList: inspectData.inspectTable,

        작업내용: "",
        작업일시: "",
        작업장소: "",
        작업업체: "",
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
  },
};
</script>
